import { seriesValueGetter } from './series-getter';

export function stateValueGetter(node): string[] | undefined {
  return seriesValueGetter('state')(node);
}
